<script setup lang="ts">
import { watch } from 'vue';
import { useRouter } from 'vue-router';
import ProgressSpinner from 'primevue/progressspinner';
import { useCalculatorsStore } from '../store/calculators';

const calculatorsStore = useCalculatorsStore();
const router = useRouter();

watch(
  () => calculatorsStore.data,
  (newValue) => {
    if (calculatorsStore.data) {
      router.push({
        name: 'HomeView',
        params: { calculatorId: calculatorsStore.data[0].id },
      });
    }
  },
  { immediate: true }
);
</script>

<template>
  <div>
    <ProgressSpinner />
  </div>
</template>
